import BIObject from '@/types/taxcard/BIObject';
import { ArrayNotEmpty, IsNumber } from 'class-validator';
import { GuestTypesEnum } from './GuestType';
import BIObjectData from './BIObjectData';

export default class APIBooking {
  @IsNumber()
  public communeId: number;

  // public isAnonymous: boolean;

  public strictAccommodation: boolean;

  public communeMailConsent: boolean;

  @ArrayNotEmpty()
  public bIObjects: BIObjectData[];

  public constructor(communeId?: number, bIObjects?: BIObjectData[], strictAccommodation?: boolean, communeMailConsent?: boolean) {
    this.communeId = communeId || 0;
    this.bIObjects = bIObjects || [];
    // NOTE: strictAccommodation will disable the select accommodation button.
    // It is being activated on accommodation deep links if the commune enabled strict accommodation selection.
    this.strictAccommodation = strictAccommodation || false;
    this.communeMailConsent = communeMailConsent || false;
  }

    public get isAnonymous() : boolean {
      if (this.bIObjects.length == 1) {
        return this.bIObjects[0].isAnonymous;
      }
      return false;
    }
  
    // public addBIObject(bIObject: BIObjectData): void {
    //   this.bIObjects = [...this.bIObjects, bIObject];
    // }
  
    public isDonation(): boolean {
      if (this.bIObjects.length == 1) {
        return this.bIObjects[0].guestType == GuestTypesEnum.donation;
      }
      return false;
    }

  // public dehydrate(): string {
  //   return JSON.stringify(this);
  // }

  // public static hydrate(json: string): APIBooking | null {
  //   const data = JSON.parse(json);
  //   if (!data) {
  //     return null;
  //   }
  //   const { bIObjects, communeId, strictAccommodation, communeMailConsent } = data;
  //   return new APIBooking(
  //     communeId,
  //     bIObjects && bIObjects.map((t: any) => BIObjectData.hydrate(bIObjects) || []),
  //     strictAccommodation,
  //     communeMailConsent
  //   );
  // }
}
